import Enum from './Enum'

class FlowStateEnum extends Enum {
  constructor() {
    super()
    this.RUNNING = 0
    this.STOPPED = 1
    this.PAUSED = 2
    this.DEBUGGING = 3
  }
}

export default Object.freeze(new FlowStateEnum())
